import type { GameMeta } from '@gmp/game-sdk';

export const conspiracyClubMeta = {
  id: 'conspiracy-club',
  name: 'Conspiracy Club',
  tagline: 'Pin the clues, pull the strings, and quietly steer the theory your way.',
  description:
    'Something ridiculous happened and nobody can explain it. Together you build a theory board: everyone pins a clue, statement or connection to the suspects, places and explanations, then ties strings between the clues. Each of you has a secret agenda, like making the Mayor\'s Hat the prime suspect or linking the Bakery to the Moon. The hottest cards on the board become the official theory. At the end, guess each other\'s agendas, vote for the funniest clue, and see who was pulling the strings. Play in one sitting or over a few days.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [15, 30],
  usesMedia: false,
  modes: [{ id: 'board', name: 'Theory board', description: 'One mystery, two or three rounds of clues and strings, then the agendas come out.' }],
  theme: { primary: '#e2b04a', secondary: '#c8343c', background: '#1d1712', ink: '#f4ead6' },
  readiness: 'beta',
  genre: 'Collaborative mystery, secret agendas',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 90],
    match: { quick: '15–25 min', daily: '5–7 days' },
    difficulty: 'medium',
    tags: ['funny', 'social', 'hidden agendas', 'deduction'],
  },
  instructions: [
    { icon: 'EyeOff', title: 'Get your agenda', body: 'A ridiculous event happened. You secretly get an agenda about which suspect, place or explanation should end up central, like "Link the Bakery to the Moon".' },
    { icon: 'PenLine', title: 'Pin a clue', body: 'Each round, add one clue (pinned to one card), statement (a suspect says something about a card) or connection (two cards), with a short line of your own.' },
    { icon: 'Spline', title: 'Pull a string', body: 'Then tie one string from a clue card to another card. Cards with more strings and clues get more heat; the hottest suspect, place and explanation are the theory.' },
    { icon: 'Search', title: 'Expose the agendas', body: 'Guess up to three players\' agendas (+2 each) and vote for the funniest clue (+1 a vote, up to 3). A fulfilled agenda scores its card\'s points, +2 more if hardly anyone saw it coming.' },
  ],
} satisfies GameMeta;
